import { apiRequest } from '@/api/client';
import type { AuthMode } from '@/config/env';
import { canviaIdioma, type Idioma } from './index';

export async function desaIdiomaPerfil(idioma: Idioma, mode: AuthMode): Promise<void> {
  await canviaIdioma(idioma);
  if (mode === 'mock') return;
  try {
    await apiRequest('/me/preferencies', { method: 'PUT', json: { idioma } });
  } catch {
    /* empty */
  }
}
